<cc-ng1-user-list
  [userStats]="userStats"
  [userList]="userList"
  [state]="state"
  [userIndex]="id"
  *ngIf="userStats && userList"
></cc-ng1-user-list>

<cc-section>
  <cc-ng1-users-alert [userStats]="userStats" *ngIf="userStats"></cc-ng1-users-alert>
  <cc-ng1-user-edit
    [user]="user"
    [userStats]="userStats"
    [userIndex]="id"
    [state]="state"
    *ngIf="user && userStats"
  ></cc-ng1-user-edit>
</cc-section>
